module.exports = __webpack_public_path__ + "static/media/protect-fatal-disease.9f03e7cf.png";